import React from 'react';
import * as S from './Polices.styles';
import CustomRadioButton from '../../../../../../stories/core-components/RadioButton/RadioButton';
import LocationBox from '../LocationPoints/LocationPoints';
import Icon from '../../../../../../stories/core-components/IconsSelector';
import ContentUnavailable from './../../../../../pages/StoriesTestPage/SrpPage/SrpErrorStates/ContentUnavailable';
import {SEAT_LAYOUT} from './../../../../../config/messages';
import Loader from './../../SrpLoader/Loader/Loader';

const PolicesContent = (props) => {
  const {cancellationPolicyData,isLoading,error} = props;
  if(isLoading){
    return(    <S.ContentWrapper> <Loader /></S.ContentWrapper> );
    
  }
  if(error){
    return( <S.ContentWrapper>
      <ContentUnavailable text={SEAT_LAYOUT.POLICY_ERROR}></ContentUnavailable>
      </S.ContentWrapper>)
  }
  if(cancellationPolicyData){
    return ( <S.ContentWrapper>
      <div dangerouslySetInnerHTML={{__html:cancellationPolicyData}} />
      </S.ContentWrapper>)
 
  }
   return( <S.ContentWrapper>
    <ContentUnavailable text={SEAT_LAYOUT.POLICY_ERROR}></ContentUnavailable>
    </S.ContentWrapper>)
;
 
}
export default PolicesContent;
